<template>
  <v-main class="page-ticket page-ticket-mine">
    <v-overlay absolute :value="isLoading">
      <v-progress-circular
          indeterminate
          size="24"
      />
    </v-overlay>
    <AppBar :back="customBack"/>

    <v-layout fill-height column>
      <v-container flex-fill fluid>

        <div class="ticket-desc-block">
          <v-btn block depressed :ripple="false"
                 class="btn-see-ticket btn-animation"
                 @click="ticketInfo();">
            티켓에 대해 알아보아요!
            <v-spacer/>
            <i class="ez-dms-arr-right-md"></i>
          </v-btn>
        </div>

        <!-- 직접 티켓 등록하기 -->
        <div class="ticket-register-block" v-if="!isSamsungFire && canRegisterDirectTicket">
          {{ isWhoyoumind ? "직접 티켓 구매하기" : "직접 티켓 등록하기"}}&nbsp;&nbsp;&nbsp;
          <v-btn fab depressed color="primary"
                 class="btn-ticket-register"
                 @click="registTicket">
            <i class="ez-dms-add"></i>
          </v-btn>
        </div>

        <!-- 보유중 티켓이 없을경우 -->
        <article v-if="ticketList.length === 0" class="ticket-list no-data">
          <div class="no-data-text">
            현재 보유 중인 티켓이 없습니다.
          </div>
        </article>
        <!-- 티켓 리스트 -->
        <article v-else class="ticket-list">
          <div v-for="(ticket, index) in ticketList" :key="index"
               class="ticket-list-item"
               :class="`ticket-list-item--${getTicketStateTemp(ticket).class}`"
          >
            <div class="ticket">
              <div class="ticket-info">
                <div class="date">
                  {{ getTicketStateDate(ticket) }}
                </div>
                <div class="name">{{ ticket.ticketName }}</div>
                <div class="desc">
                  {{ ticket.dscrt }}
                </div>
                <v-chip small color="primaryLight" text-color="primary" class="py-2 mt-2"
                        v-if="info.visible && ticket.ticketState === '03'">
                  <template>
                    선착순
                    <v-divider vertical class="mx-2"/>
                  </template>
                  <b>잔여 {{ ticket.remainCnt }}</b>
                </v-chip>
              </div>
              <div class="ticket-state">
                <v-btn text :ripple="false"
                       class="btn-ticket-state"
                       :class="`btn-ticket-state--${getTicketStateTemp(ticket).class}`"
                       @click="ticketSelect(index, ticket)">
                  {{ getTicketStateTemp(ticket).text }}
                </v-btn>
              </div>
            </div>
          </div>
        </article>

        <Modal :dialog="dialog" :str="modalText" @close="modalClose"/>
        <ModalConfirm :dialog="confirmdialog" :str="confirmmodalText"
                      :btn1="{str:btnStr1,event: btnEvent1}" :btn2="{str:btnStr2,event: btnEvent2, color:'#FF4A4A'}"
                      :isClose="isClose" @confirmClose="confirmmodalClose"
                      @close="confirmmodalClose" @delete="newTravelIntro" @newTravel="setMemberResultDel"
                      @startTravel="goTravelPage('S')" @cancel="cancel"/>
      </v-container>
    </v-layout>

    <v-footer v-if="memberGb === '02'"
              app fixed grow color="white" class="content-footer"
    >
      <div class="footer-btns">
        <BlackBtn x-large str="티켓 구매하러가기" @click="goByTicket('N')"/>
      </div>
    </v-footer>

  </v-main>
</template>
<script>
import store from '../../store'
import Modal from "@/components/layout/modal/Modal";
import ModalConfirm from "@/components/layout/modal/ModalConfirm.vue";
import BlackBtn from "@/components/btns/BlackBtn"
import {mixinAuth, mixinTravel, mixinTrial} from "@/mixins";
import moment from "moment/moment";

export default {
  components: {
    BlackBtn,
    Modal,
    ModalConfirm
  },
  mixins: [mixinAuth, mixinTravel, mixinTrial],
  data: () => ({
    ticketList: [],
    dialog: false,
    modalText: '',
    confirmdialog: false,
    confirmmodalText: '',
    usePsbYn: '',
    remainCnt: 0,
    travelApplNo: 1,
    travelApplStepCd: '0001',
    memberStepApplCnt: 0,
    goTravelApplStepCd: '0001',
    btnStr1: '',
    btnStr2: '',
    btnEvent1: '',
    btnEvent2: '',
    btnGubun: 0,
    isClose: false,
    ticketSelectCnt: 0,
    weatherStatus: null,
    isLoading: false,
    current: 0
  }),
  watch: {
    ticketRefreshTriggerCount(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal) this.getMyTicketList();
      }
    }
  },
  computed: {
    ticketRefreshTriggerCount () {
      return store.state.ticket.ticketRefreshTriggerCount
    },
    memberGb () {
      return store.state.auth.authUser.memberGb
    },
    canRegisterDirectTicket () {
      // 체험만료 아닌 상태 or 체험 대기상태
      if ((this.hasActiveTrial && !this.expiredTrial) || (this.hasTrial && this.waitTrial)) return false
      // 무명부 고객사만. 추후 변경예정
      return store.state.client.contract.rgstYn === "02"
    },
    info() {
      if (this.isSamsungFire) {
        return {
          visible: true
        }
      } else {
        return {
          visible: false
        }
      }
    }
  },
  created() {
  },
  mounted() {
    // 가장 최근의 여행지원서 결과 (사전검사) 여부 조회
    this.getBeforeAppResultList();
    //솔루션 매핑여부 확인
    this.getMappingSolution();
    //내 티켓 리스트 API
    this.getMyTicketList()
  },
  methods: {
    registTicket() {
      if (this.isWhoyoumind) {
        if (!this.expiredTrialTicket && (this.hasActiveTrial && this.expiredTrial)) {
          this.$alert('이용하시던 체험권이 있어요.<br>체험권 "이어하기"를 통해<br>여행을 계속할 수 있어요.')
          return
        }
        this.continueDirectTicket()
      } else {
        this.movePage('/fo/TicketRegister');
      }
    },
    getTicketStateTemp(item) {
      if (item.hasTrial) {
        if (item.ticketState === '01') return {text: '체험중', class: 'using'}
        if (item.ticketState === '02') return {text: '이어하기', class: 'available'}
        if (item.ticketState === '05') return {text: '만료', class: 'expired'}
      }

      if (item.ticketState === '01') return {text: '이용중', class: 'using'}
      if (item.ticketState === '02') return {text: '중지중', class: 'restart'}
      if (item.ticketState === '03') return {text: '시작하기', class: 'available'}
      if (item.ticketState === '04') return {text: '대기', class: 'standby'}
      if (item.ticketState === '05') return {text: '만료', class: 'expired'}
      if (item.ticketState === '06') return {text: '사용완료', class: 'expired'}
      return {text: '', class: ''}
    },
    getTicketStateDate(item) {
      if (item.ticketState === '01' || item.ticketState === '02' || item.ticketState === '06') {
        return `${item.usePeriodStartDt} ~ ${item.usePeriodEndDt}`
      }
      if ((item.ticketState === '03' || item.ticketState === '04' || item.ticketState === '05') && item.payYn !== 'Y' && item.periodLimitNoneYn !== 'Y') {
        return `${item.ticketUseStartDt}~ ${item.ticketUseEndDt}`
      }
    },
    ticketSelect(n, item) {
      if (item.hasTrial && item.ticketState === '02') {
        this.dispatchBalanceCheckAvailable()
        return
      }

      if (item.ticketState === '03') {
        this.remainCnt = this.ticketList[n].remainCnt
        this.current = n
        // 여행지원서 완료여부 확인
        this.goByTicket('Y')
      } else if (item.ticketState === '02') {
        this.movePage('/fo/solutionPause');
      }
    },
    ticketStart(checkYn) {
      if (this.isSamsungFire && checkYn === 'Y') {
        //삼성 티켓 체크
        this.getFireTicketCheck()
      } else {
        if (checkYn === 'Y') {
          const validEndDt = this.ticketList[this.current].validperiodEndDt
          const validStartDt = this.ticketList[this.current].validperiodStartDt
          const now = moment().format('YYYY.MM.DD')
          if (now < validStartDt || now > validEndDt) {
            this.$alert('이용처리 기간이 아닙니다.')
            return false
          }

          const selected = this.ticketList[this.current];
          let confirmMessage = "여행을 시작하시겠어요?"
          if (selected.allowsRealtalkService) confirmMessage += "<br>찐한 대화 일정 선택까지 완료하셔야 <br>여행이 시작됩니다.";

          this.$confirm(confirmMessage, {
            persistent: false,
            showClose: true,
            actions: {
              false: {text: '아니오'},
              true: {text: '예'}
            }
          }).then(result => {
            if (result) {
              // //티켓 사용
              this.insertUserSolution(this.ticketList[this.current]) // 솔루션 매핑 후 -> 티켓 사용처리 로직 수정
            }
          })
        } else {
          this.$router.push({name: '티켓 선택 EZN', query: {'payGo': true}})
        }
      }
    },
    // 솔루션 매핑
    async insertUserSolution (ticketList) {
        this.isLoading = true
        await store.dispatch('insertUserSolution', this.$_payload('ticketUserPo', ticketList))
            .then(async res => {
              if (res.success) {
                const { allowsRealtalkService, goodsNo }  = res.data;
                store.commit('setContract', {
                  ...store.state.client.contract,
                  allowsRealtalkService,
                  goodsNo
                })
                const url = store.state.client.contract.allowsRealtalkService ? '/fo/guideSelect' :'/fo/intro';
                this.movePage(url);
              } else {
                this.$alert(res.msg)
              }
            })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    modalClose() {
      this.dialog = false;
      //this.movePage('/user');
    },
    confirmmodalClose() {
      this.confirmdialog = false;
      //this.movePage('/user');
    },
    newTravelIntro() {
      this.getMemberStepCnt()
      //this.$router.push({ name: "travelIntro", params: { travelApplStepCd: this.goTravelApplStepCd, startType: 'S' } });
    },
    ticketInfo() {
      this.movePage('/fo/ticketInfo');
    },
    ticketCheck(useYn) {
      if (this.usePsbYn === 'N') { //유효기간 D-85일 이하 이면 사용 불가 가용가능(Y), 불가능(N)
        this.$alert('집중관리(상담) 티켓은 서비스 종료 전</br> 3개월까지만 발급 가능합니다.</br> 기업체 담당자에게 문의해주세요.')
        // this.modalText = '집중관리(상담) 티켓은 서비스 종료 전</br> 3개월까지만 발급 가능합니다.</br> 기업체 담당자에게 문의해주세요.'
        // this.dialog = true
      } else if (this.weatherStatus.stateCd == '01') {
        this.$alert("마음날씨가 '쨍쨍'인 경우,</br> 집중관리(상담)가 진행되지 않습니다.</br> 집중관리(상담)가 필요한 경우가 생기면,</br> 다시 여행 지원서를 작성해 보세요.")
        // this.modalText = "마음날씨가 '쨍쨍/맑음'인 경우,</br> 집중관리(상담)가 진행되지 않습니다.</br> 집중관리(상담)가 필요한 경우가 생기면,</br> 다시 여행 지원서를 작성해 보세요."
        // this.dialog = true
      } else if (this.remainCnt <= 0) {
        this.$alert('집중관리(상담) 받을 수 있는</br> 기회가 선착순으로 마감되었습니다.</br> 기업체 담당자에게 문의해 주세요.')
        // this.modalText = '집중관리(상담) 받을 수 있는</br> 기회가 선착순으로 마감되었습니다.</br> 기업체 담당자에게 문의해 주세요.'
        // this.dialog = true
      } else {
        if (useYn === 'Y') {

          this.$confirm('집중관리를 시작하시겠어요?<br>찐한 대화 일정 선택까지 완료하셔야 집중 관리가 시작됩니다.', {
            persistent: false,
            showClose: true,
            actions: {
              false: {text: '아니오'},
              true: {text: '예'}
            }
          }).then(result => {
            if (result) {
              // //티켓 사용
              this.insertUserSolution(this.ticketList[this.current]) // 솔루션 매핑 후 -> 티켓 사용처리 로직 수정
            }
          })
        }
      }
    },
    setConfirmMessage1() {
      this.confirmdialog = false;
      this.confirmmodalText = "작성 중인 여행지원서가 있습니다. <br>이어서 하시겠습니까?";
      this.btnStr1 = "새로 작성하기";
      this.btnStr2 = "이어서 하기";
      this.btnEvent1 = 'cancel';
      this.btnEvent2 = 'startTravel';
      this.btnGubun = 1;
      this.isClose = false;
      this.confirmdialog = true;
    },
    setConfirmMessage2() {
      this.confirmdialog = false;
      this.confirmmodalText = "여행지원서를 새로 작성하시면 <br>전에 진행한 여행지원서는 삭제됩니다.";
      this.btnStr1 = "취소";
      this.btnStr2 = "새로 작성하기";
      this.btnEvent1 = 'cancel';
      this.btnEvent2 = 'newTravel';
      this.btnGubun = 2;
      this.isClose = false;
      this.confirmdialog = true;
    },
    setConfirmMessage3() {
      // this.confirmdialog = false;
      // this.confirmmodalText = "현재 완료한 여행지원서가 없습니다.<br/>먼저 여행지원서를 작성해주세요.";
      // this.btnStr1 = "취소";
      // this.btnStr2 = "작성하기";
      // this.btnEvent1 = 'close';
      // this.btnEvent2 = 'delete';
      // this.btnGubun = 2;
      // this.isClose = false;
      // this.confirmdialog = true;

      this.$confirm('현재 완료한 여행지원서가 없습니다.<br/>먼저 여행지원서를 작성해주세요.', {
        persistent: false,
        showClose: false,
        actions: {
          false: {text: '취소'},
          true: {text: '작성하기'}
        }
      }).then(result => {
        if (result) {
          this.newTravelIntro()
        }
      })
    },
    cancel() {
      this.confirmdialog = false;
      if (this.btnGubun == 1) {
        this.setConfirmMessage2();
      }
      //  else {
      //     this.setConfirmMessage1();
      // }
    },
    goTravelPage(type) {
      // travelApplStepCd = 사전검사(0001), 중간검사(0002), 사후검사(0003)
      // startType = 단계별 처음(S), 단계별 다시시작(R)
      // 단계별 다시시작은 각 검사 단계의 결과까지 보았으나 다시 검사를 하는 경우 사용한다.
      this.$router.push({name: "travelIntro", query: {travelApplStepCd: this.travelApplStepCd, startType: type}});
    },
    async getMyTicketList() {  // 내 티켓 리스트 API
      await store.dispatch('getMyTicketList', this.$_payload('so', []))
        .then(res => {
          if (res.success) {
            this.ticketList = res.data

            for (let i = 0; i < this.ticketList.length; i++) {
              if (this.ticketList[i].ticketState == '03') {
                this.ticketSelectCnt++;
              }
            }

          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {

        })
    },
    guideSelect() {
      this.movePage('/fo/guideSelect');
    },
    async getUseOrdDtlNoGuide() {  // 유저 티켓 사용 API
      await store.dispatch('getUseOrdDtlNoGuide')
        .then(res => {
          if (res.success) {
            if (res.data != null) {
              this.movePage('/fo/guideSelect');
            }
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {

        })
    },
    async getFireTicketCheck() {  // 유저 삼성 티켓 체크 API
      await store.dispatch('getFireTicketCheck')
        .then(res => {
          if (res.success) {
            this.usePsbYn = res.data.usePsbYn
            this.remainCnt = res.data.remainCnt
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
          this.usePsbYn = 'N'
          this.remainCnt = 0
        })
        .finally(() => {
          //여행지원서 마음날씨 조회
          this.getMemberApplResultLast()
        })
    },
    async getMemberApplResultLast() { // 여행지원서 마지막 결과 확인
      await store.dispatch('getMemberApplResultLast', this.$_payload('so', [{'travelApplNo': 1}]))
        .then(res => {
          if (res.success) {
            if (res.data != null) {
              this.goTravelApplStepCd = res.data.travelApplStepCd;
              this.travelApplStepCd = res.data.travelApplStepCd;
              this.getApplResultForWeatherStatus(res.data);
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch(() => {
        })
        .finally(() => {
          store.commit('setInitApplResult', false)
        })
    },
    async getApplResultForWeatherStatus(so) {  // 여행지원서 마음날씨 구분 값 조회 Api
      await store.dispatch('getApplResultForWeatherStatus', this.$_payload('so', [
        {'travelApplNo': so.travelApplNo},
        {'unitNo': so.unitNo},
        {'travelApplStepCd': so.travelApplStepCd},
        {'memberStepApplCnt': so.memberStepApplCnt},
        {'memberNo': so.memberNo},
        {'areaCritType': '01'},
        {'areaCrit': '00'},
      ]))
        .then(res => {
          if (res.success) {
            //this.weatherUrl = res.data.imgPath;
            this.weatherStatus = res.data
          } else {
            console.log(res.msg)
            this.weatherStatus = null
          }
        })
        .catch(error => {
          console.error(error)
          this.state = "";
        })
        .finally(() => {
          this.ticketCheck('Y')
        })
    },
    async goByTicket(checkYn) { // 여행지원서 완료여부 확인
      await store.dispatch('getMemberApplResultCnt', this.$_payload('so', [
        {'travelApplNo': 1},
        {'memberNo': this.userKey},
        {'travelApplStepCd': ''}
      ]))
        .then(res => {
          if (res.success) {
            if (res.data === 0) {
              //this.confirmmodalText = "현재 완료한 여행지원서가 없습니다. 먼저 여행지원서를 작성해주세요.";
              //this.confirmdialog = true;
              this.setConfirmMessage3()
            } else {
              //this.$router.push({ name: "travelIntro", params: { travelApplStepCd: "0001", startType: 'S' } });
              if(this.isBeforeApplResultYn || store.getters.useOrdDtl.travelYn === 'Y'){
                this.ticketStart(checkYn)
              } else {
                this.setConfirmMessage3()
              }
            }
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    async getMemberStepCnt() {
      await store.dispatch('getMemberStepCnt', this.$_payload('so', [{'travelApplNo': this.travelApplNo}, {'memberNo': this.userKey}, {'travelApplStepCd': this.travelApplStepCd}]))
        .then(res => {
          if (res.success) {
            this.memberStepApplCnt = res.data;
            this.getProgressStep(res.data);
          } else {
            this.memberStepApplCnt = 1;
            this.goTravelPage('S');
          }
        })
        .catch(error => {
          console.error(error)
          this.memberStepApplCnt = 1;
          this.goTravelPage('S');
        })
        .finally(() => {
        })
    },
    async getProgressStep() {
      await store.dispatch('getProgressStep', this.$_payload('so', [
        {'travelApplNo': this.travelApplNo},
        {'unitNo': 1},
        {'memberNo': this.userKey},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
        .then(res => {
          if (res.success) {
            if (res.data != null) {
              if (10 === res.data.unitDtlSeq) {   // 완료한 여행지원서
                if(store.getters.isApplResult === 'success') {
                  this.goTravelPage('RR');
                } else {
                  this.goTravelPage('S');
                }

              } else {    // 진행중인 여행지원서
                this.$confirm('작성 중인 여행지원서가 있습니다. <br>이어서 하시겠습니까?', {
                    persistent: false,
                    showClose: true,
                    actions: {
                      false: {text: '새로 작성하기'},
                      true: {text: '이어서 하기', color: '#ff4a4a'}
                    }
                  }).then(result => {
                    if (result === true) { // 이어서 하기
                      if(store.getters.isApplResult === 'success') {
                        this.goTravelPage('RR');
                      } else {
                        this.goTravelPage('S');
                      }
                    } else if (result === false) { // 새로하기
                      this.$confirm('여행지원서를 새로 작성하시면 <br>전에 진행한 여행지원서는 삭제됩니다.', {
                        actions: {
                          false: {text: '취소'},
                          true: {text: '새로 작성하기', color: '#ff4a4a'}
                        }
                      }).then(result => {
                        if (result === true) { // 새로 작성하기
                          this.setMemberResultDel()
                        }
                      })
                    }
                  })
              }

            } else {
              this.goTravelPage('S');
            }
          } else {
            console.log(res.msg)
            this.pageCnt = 0;
            this.step = 0;
          }
        })
        .catch(error => {
          console.error(error)
          this.pageCnt = 0;
          this.step = 0;
        })
        .finally(() => {
        })
    },
    async setMemberResultDel() {
      await store.dispatch('setMemberResultDel', this.$_payload('so', [
        {'travelApplNo': this.travelApplNo},
        {'memberNo': this.userKey},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
        .then(res => {
          if (res.success) {
            if (res.data != null) {
              if(store.getters.isApplResult === 'success') {
                  this.goTravelPage('RR');
                } else {
                  this.goTravelPage('S');
                }
            }
          } else {
            console.log(res.msg)
            this.pageCnt = 0;
            this.step = 0;
          }
        })
        .catch(error => {
          console.error(error)
          this.pageCnt = 0;
          this.step = 0;
        })
        .finally(() => {
        })
    },
    customBack() {
      if (!this.isLoading) {
        this.movePage('/fo/suitcase');
      }
    },
    async getMappingSolution() { // 솔루션 매핑여부 확인
      await store.dispatch('getMappingSolution')
          .then(res => {
            if (res.success) {
              if (res.data !== null) {
                store.commit('setSolMappingYnSuccess')
              } else {
                store.commit('setSolMappingYnFail')
              }
            } else {
              store.commit('setSolMappingYnFail')
            }
          })
          .catch(() => {
            store.commit('setSolMappingYnFail')
          })
          .finally(() => {
            store.commit('setInitSolMappingYn', false)
          })
    },
  }
}
</script>
